import { Theme } from './types'

const darkTheme: Theme = {
  name: 'dark',
  sizes: {
    button: {
      height: '52px',
    },
    texts: {
      fontSize: {
        xs: '11px',
        s: '14px',
        m: '17px',
        l: '20px',
        xl: '34px',
      },
      lineHeight: {
        xs: '12px',
        s: '16px',
        m: '20px',
        l: '22px',
        xl: '24px',
      },
    },
    radiuses: {
      xs: '4px',
      s: '4px',
      m: '8px',
      l: '12px',
      xl: '16px',
    },
  },
  colors: {
    background: {
      primary: '#1D1E22',
      secondary: '#202021',
    },
    text: {
      primary: '#FFFFFF', // белый
      secondary: '#FAFCFFA6', // белый с прозрачностью
      link: '#4A6BFC', // синий
      success: '#14F37B', // зеленый
      error: '#E83550', // красный
      golden: '#F3CA14', // желтый
      sub: '#707579', // серый
    },
    button: {
      primary: {
        background: '#4A6BFC',
        disabled: '#28292d',
        text: '#FFFFFF',
      },
      secondary: {
        background: '#2e2f34',
        disabled: '#2e2f3450',
        text: '#FFFFFF',
      },
      golden: {
        background: '#4A6BFC',
        disabled: '#F0F5FA0D',
        text: '#FFFFFF',
      },
    },

    borders: {
      legendary: '#FF8000',
      epic: '#A335EE',
      rare: '#0070DD',
      uncommon: '#1EFF00',
      common: '#FFFFFF',
      default: '#313236',
      secondary: '#505055',
    },
  },
}

export { darkTheme }
